import React from 'react'
import SvgIcon, { iconList } from '../../share/components/iconSVG'
import person from '../../../assets/pictures/person-insurance.png'
import './styles.css'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const FormInsurance = ({ data }) => {

    const {
        findInsurance,
        name,
        setName,
        lastName,
        setLastName,
        email,
        setEmail,
        phone,
        setPhone,
        destination,
        setDestination,
        arrival,
        setArrival,
        departure,
        setDeparture,
        msgError,
        dateArrival,
        setDateArrival,
        dateDeparture,
        setDateDeparture,
        handleDateChangeArrival,
        handleDateChangeDeparture,
        selectedDateArrival,
        selectedDateDeparture,
        setQtyPersons,
        dataSucces,
        succesScreen
    } = data()

    return (
        <div className='contain-insurance'>
            <section className='contain-form-insurance'>
                <p>
                    <SvgIcon name={iconList.IconCheckSucces} size={60} color={'#004274'} />
                    Dejanos los siguientes datos y te contactaremos y enviaremos tu cotización
                </p>
                {
                    succesScreen == true ?
                       <div className='msg-succes-insurance'>
                            <SvgIcon name={iconList.IconCheckSucces} size={60} color={'#008000'}/>
                            <h3>Enviado correctamente</h3>
                            <div>
                                <h3>Datos del Solicitante:</h3>
                                <ul>
                                    <li>Nombre: <span>{dataSucces.name}</span></li>
                                    <li>Apellido: <span>{dataSucces.lastname}</span></li>
                                    <li>Email: <span>{dataSucces.email}</span></li>
                                    <li>id: <span>{dataSucces.id}</span></li>
                                </ul>
                            </div>
                       </div>
                    :

                    <form action="" onSubmit={e => findInsurance(e)}>
                    <div className='campos-one-insurance'>
                        <label htmlFor="">
                            Nombre
                        </label>
                        <input type="text" onChange={(e) => { setName(e.target.value) }} />
                    </div>
                    <div className='campos-one-insurance'>
                        <label htmlFor="">
                            Apellidos
                        </label>
                        <input type="text" onChange={(e) => { setLastName(e.target.value) }} />
                    </div>
                    <div className='campos-one-insurance'>
                        <label htmlFor="">
                            Telefono
                        </label>
                        <input type="text" onChange={(e) => { setPhone(e.target.value) }} />
                    </div>
                    <div className='campos-one-insurance'>
                        <label htmlFor="">
                            Correos
                        </label>
                        <input type="email" onChange={(e) => { setEmail(e.target.value) }} />
                    </div>
                    <div className='campos-one-insurance'>
                        <label htmlFor="">
                            Destino
                        </label>
                        <input type="text" onChange={(e) => { setDestination(e.target.value) }} />
                    </div>
                    <div className='campos-double-insurance'>
                        <div className='div-campos-double-insurance'>
                            <label htmlFor="">Fecha: Desde</label>
                            <div className='input-insurance date-insurance'>
                                <SvgIcon name={iconList.IconCalendar} size={30} color={'#004274'} />
                                <DatePicker
                                    selected={selectedDateArrival}
                                    onChange={(e) => { handleDateChangeArrival(e) }}
                                    dateFormat="yyyy-MM-dd"
                                    className='date-insurance-modal'
                                />
                            </div>
                        </div>
                        <div className='div-campos-double-insurance'>
                            <label htmlFor="">Fecha:Hasta</label>
                            <div className='input-insurance date-insurance'>
                                <SvgIcon name={iconList.IconCalendar} size={30} color={'#004274'} />
                                <DatePicker
                                    selected={selectedDateDeparture}
                                    onChange={(e) => { handleDateChangeDeparture(e) }}
                                    dateFormat="yyyy-MM-dd"
                                    className='date-insurance-modal'
                                />
                            </div>
                        </div>
                    </div>
                    <div className='campos-one-insurance'>

                        <label htmlFor="">Cantidad de personas</label>
                        <div className='input-insurance select-insurance'>
                            <SvgIcon name={iconList.IconPeoples} size={30} color={'#004274'} />
                            <select name="" id="" onChange={e => setQtyPersons(e.target.value)}>
                                <option value="1">1 persona</option>
                                <option value="2">2 persona</option>
                                <option value="3">3 persona</option>
                                <option value="4">4 persona</option>
                                <option value="5">5 persona</option>
                                <option value="6">6 persona</option>
                                <option value="7">7 persona</option>
                                <option value="8">8 persona</option>
                            </select>
                        </div>

                    </div>
                    {
                        msgError &&
                        <div className='error-message-insurance'>
                            <p>Todos los campos son obligatorios</p>
                        </div>
                    }

                    <button className='send-insurance'>Enviar</button>
                </form>
                }
                
            </section>
            <section className='contain-img-insurance'>
                <img src={person} alt="" />
            </section>
        </div>
    )
}

export default FormInsurance